import ProductThumbnailView from '@component/product-thumbnail';
import CustomProductThumbnailView from '../views/CustomProductThumbnailView';
import Constants from '../util/Constants';

export default class ProductThumbnailFactory {
  static getView(panelProperties, panelConfig) {
    return ProductThumbnailFactory.isProsHomePageRedesignProductThumbnail(panelProperties) ||
      ProductThumbnailFactory.isSlimProductThumbnail(panelProperties) ||
      ProductThumbnailFactory.isGridRedesignProductThumbnail(panelProperties, panelConfig) ||
      ProductThumbnailFactory.isProsRedesignProductThumbnail(panelConfig, panelProperties) ||
      ProductThumbnailView.extend({
        tagName: 'li',
      });
  }

  static isSlimProductThumbnail(panelProperties) {
    const enabled = panelProperties.slimProductThumbnailEnabled && panelProperties.prosZoneRedesignEnabled;
    return enabled ? CustomProductThumbnailView.extend({
      tagName: 'li',
      className: 'customProductThumbnailContainer slimProductThumbnail',
      onBeforeRender() {
        this.$el.css('width', 160);
      },
      getSwatchesSizeOptions() {
        return {
          swatchesWidth: 140,
          swatchesPadding: 0,
          swatchesButtonWidth: Constants.CAROUSEL_SWATCHES_BUTTON_WIDTH,
        };
      },
      getCarouselBreakpoint() {
        return 3;
      },

    }) : undefined;
  }

  static isProsRedesignProductThumbnail(panelConfig, panelProperties) {
    const isProsReDesignEnabled = panelProperties.prosZoneRedesignEnabled &&
      panelConfig.orientation === Constants.CAROUSEL_TYPE.HORIZONTAL;
    return isProsReDesignEnabled ? CustomProductThumbnailView.extend({
      tagName: 'li',
      className: 'customProductThumbnailContainer',
    }) : undefined;
  }

  static isProsHomePageRedesignProductThumbnail(panelProperties) {
    const enabled = panelProperties.prosZoneRedesignEnabled && panelProperties.redesignHomePageThumbnailEnabled;
    return enabled ? CustomProductThumbnailView.extend({
      tagName: 'li',
      className: 'HomePageThumbnailContainer',
      getSwatchesSizeOptions() {
        return {
          swatchesWidth: 292,
          swatchesPadding: 0,
          swatchesButtonWidth: 40,
        };
      },

      getCarouselBreakpoint() {
        return 6;
      },

    }) : undefined;
  }

  static isGridRedesignProductThumbnail(panelProperties, panelConfig) {
    const enabled = panelProperties.prosZoneRedesignEnabled && panelConfig.viewType === 'grid';
    return enabled ? CustomProductThumbnailView.extend({
      tagName: 'li',
      onBeforeRender() {
      },
      className: 'ProsGridItemRedesignEnabled',
    }) : undefined;
  }
}
